module.exports = __webpack_public_path__ + "55a9aa1313decabb9996f210447bc56d.png";


//////////////////
// WEBPACK FOOTER
// ./src/image/stora.png
// module id = 551
// module chunks = 0